'use es6';

import { DEFAULT_API_DOMAIN } from './constants';
import { ERROR_MESSAGES } from './messages'; // This mocked version of a `hub-http` client is used when validating and/or resolving `hub-http` failed
// leaving to this mocked client instance which will always fail, the intention here
// is to during runtime let the users know they have a faulty installation of `laboratory-lib`
// this can be caused due to missing `hub-http` or `hubspot-dlb` dependencies.

const MOCK_HTTP_CLIENT = {
  get: () => new Promise((_onSuccess, onError) => onError(ERROR_MESSAGES.faultyHttpModule)),
  post: () => new Promise((_onSuccess, onError) => onError(ERROR_MESSAGES.faultyHttpModule))
}; // This mocked version of `quick-fetch` is used when we don't need the `quick-fetch` instance
// (e.g. when the app is using `hub-http` instead of `quick-fetch`), but in some cases
// this is is also used when validating and/or resolving `quick-fetch` failed
// this can be caused either by missing `quick-fetch` dependency or
// `quick-fetch` was not correctly installed on the App's HTML templates

const MOCK_QUICK_FETCH_CLIENT = {
  getRequestStateByName: () => ({
    whenFinished: () => {},
    onError: callback => {
      callback(null, ERROR_MESSAGES.faultyQuickFetchModule);
    }
  }),
  makeEarlyRequest: () => {},
  getApiUrl: () => DEFAULT_API_DOMAIN
};
export { MOCK_HTTP_CLIENT, MOCK_QUICK_FETCH_CLIENT };